import polyfillContains from '../common/polyfills/Node/prototype/contains';
import { PermissionCoreApp } from './app/permission-core-app';

polyfillContains();

export default new PermissionCoreApp();
